import featureFlags, { FeatureFlags } from './featureFlags'
import { Params } from '../../../lib/splitParams/types'
import constants from '@bt-react/constants'
import { Role } from '../../constants/roles'

export interface DevicePermissions {
  kind: string
}

export interface InputDeviceMapInfo {
  kind: string
  label: string
}

export interface ConfigReducer {
  activeBridge: string | null
  bridgeName: string
  channelId: number | undefined
  currentNetworkQuality: number | null
  devicePermissions: DevicePermissions[]
  debug: boolean
  isLocalBridge: boolean
  featureFlags: FeatureFlags
  hasErrorToken: boolean
  host: string
  inputDevices: Map<string, InputDeviceMapInfo>
  isFetchingToken: boolean
  maxPresenters: number
  gigOptions: Params
  role: Role | undefined
  roomname: string | null
  slidesSizeLimitBytes: number
  stats: {}
  token: string | null
  username: string | null
  webcastId: number | undefined
  networkQuality: number | null
  serviced: boolean
  userCanPresent: boolean | null
  userHasChannelRoles: boolean | null
}

export const defaultState: ConfigReducer = {
  activeBridge: null,
  bridgeName: '',
  channelId: undefined,
  currentNetworkQuality: null,
  devicePermissions: [
    { kind: 'audioinput' },
    { kind: 'videoinput' }
  ],
  debug: false,
  isLocalBridge: false,
  featureFlags,
  gigOptions: {},
  hasErrorToken: false,
  host: '',
  inputDevices: new Map(),
  isFetchingToken: false,
  maxPresenters: 9,
  networkQuality: null,
  role: undefined,
  roomname: null,
  slidesSizeLimitBytes: constants.slides.slidesSizeLimitBytes,
  stats: {},
  token: null,
  username: null,
  webcastId: undefined,
  serviced: false,
  userCanPresent: null,
  userHasChannelRoles: null
}

export default defaultState
